export default [
  // 交易中心
  {
    path: '/trade/:symbol',
    name: 'trade',
    meta: {
      footNotMrgin: true,
      activeName: 'exTrade',
      pageTitle: 'select', // header
      isCoOpen: true,
    },
    component: () => import('@/views/trade/index.vue'),
  },
  {
    path: '/trade',
    name: 'trade',
    meta: {
      footNotMrgin: true,
      activeName: 'exTrade',
      pageTitle: 'select', // header
      isCoOpen: true,
    },
    component: () => import('@/views/trade/index.vue'),
  },
  // 首页
  {
    path: '/',
    name: 'home',
    meta: {
      pageTitle: 'home',
      theme: 'homeOther',
      footNotMrgin: true,
      H5HideCommonHeader: true, // H5 隐藏公共导航
      isCoOpen: true,
    },
    component: () => import('@/views/home/index.vue'),
  },
];
